import type { SVGProps } from 'react';

type EmptyKeysIllustrationProps = SVGProps<SVGSVGElement>;

export const EmptyKeysIllustration = (props: EmptyKeysIllustrationProps) => (
  <svg
    viewBox="0 0 99 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z"
      fill="var(--tenant-surface-selected)"
    />
    <path
      d="M79.1998 99H19.7998V34.98C22.5995 34.9769 25.2837 33.8633 27.2634 31.8836C29.2431 29.9039 30.3567 27.2197 30.3598 24.42H68.6398C68.6368 25.8069 68.909 27.1806 69.4404 28.4617C69.9718 29.7428 70.752 30.9057 71.7359 31.8833C72.7134 32.8674 73.8764 33.6479 75.1576 34.1794C76.4388 34.711 77.8127 34.9831 79.1998 34.98V99Z"
      fill="white"
    />
    <path
      d="M49.5002 67.32C58.2483 67.32 65.3402 60.2282 65.3402 51.48C65.3402 42.7318 58.2483 35.64 49.5002 35.64C40.752 35.64 33.6602 42.7318 33.6602 51.48C33.6602 60.2282 40.752 67.32 49.5002 67.32Z"
      fill="var(--tenant-content-positive-soft)"
    />
    <path
      d="M58.0799 71.28H40.9199C39.8264 71.28 38.9399 72.1665 38.9399 73.26C38.9399 74.3535 39.8264 75.24 40.9199 75.24H58.0799C59.1735 75.24 60.0599 74.3535 60.0599 73.26C60.0599 72.1665 59.1735 71.28 58.0799 71.28Z"
      fill="var(--tenant-subtle)"
    />
    <path
      d="M64.02 79.2H34.98C33.8865 79.2 33 80.0865 33 81.18C33 82.2735 33.8865 83.16 34.98 83.16H64.02C65.1135 83.16 66 82.2735 66 81.18C66 80.0865 65.1135 79.2 64.02 79.2Z"
      fill="var(--tenant-subtle)"
    />
    <path
      d="M48.9582 50.4628L42.4307 56.9904L43.6068 58.1665L44.7829 56.9904L46.8412 59.0486L48.0173 57.8725L45.9591 55.8142L47.1352 54.6381L48.8994 56.4023L50.0756 55.2262L48.3114 53.462L50.1344 51.6389C51.7489 52.7086 53.9457 52.5322 55.3681 51.1097C56.9921 49.4858 56.9921 46.8529 55.3681 45.229C53.7442 43.6051 51.1114 43.6051 49.4875 45.229C48.065 46.6515 47.8886 48.8483 48.9582 50.4628ZM54.192 49.9335C53.2176 50.9079 51.638 50.9079 50.6636 49.9335C49.6893 48.9592 49.6893 47.3795 50.6636 46.4052C51.638 45.4308 53.2176 45.4308 54.192 46.4052C55.1664 47.3795 55.1664 48.9592 54.192 49.9335Z"
      fill="white"
    />
  </svg>
);
